import { ERA_ACTIONS } from '../../../../utils/era-eob';

const filterMergedLineItems = lineItems => {
  const lineItemsMap = new Map(
    lineItems.map(li => [`${li.serviceDate}|${li.procedureCode}`, li]),
  );
  return [...lineItemsMap.values()];
};

const getLineItems = (claim, updatedClaim, action) => {
  const lineItems =
    action === ERA_ACTIONS.MERGE_LINE_ITEMS
      ? filterMergedLineItems(claim.lineItems)
      : claim.lineItems;

  return lineItems.map(lineItem => {
    const updatedLineItem = updatedClaim.lineItems.find(
      li => li.lineItemReportId === lineItem.lineItemReportId,
    );

    return updatedLineItem || lineItem;
  });
};

export default (reportData, updatedReport, action) => {
  const updatedClaimsMap = new Map(
    updatedReport.claims.map(claim => [claim.claimReportId, claim]),
  );

  const claims = reportData.claims.map(claim => {
    const updatedClaim = updatedClaimsMap.get(claim.claimReportId);
    if (!updatedClaim) return claim;

    const lineItems = getLineItems(claim, updatedClaim, action);
    return {
      ...updatedClaim,
      lineItems,
    };
  });

  return {
    ...updatedReport,
    claims,
  };
};
